import Facebook from '../imgs/Facebook.png';
import Twitter from '../imgs/Twitter.png';
import Instagram from '../imgs/Instagram.png';
import LinkedIn from '../imgs/LinkedIn.png';
import YouTube from '../imgs/YouTube.png';
import logo_hor from '../imgs/logo_hor.png';

export default function Footer() {
  return (
    <>
      {/* ✅ Desktop Version */}
      <footer className="bg-[#0B1D26] text-white py-16 px-8 h-[480px] hidden md:block">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-16 mt-10 items-start" style={{ marginTop: '40px' }}>


          {/* Logo & Social */}
          <div>
            <img src={logo_hor} alt="Clever" className="h-[72px] w-[228px] mb-4" />
            <p className="text-[22px] text-[#7F7CA2]/70 mb-6 list-disc list-outside text-left">
              Get out of there and discover your next slope, mountain and destination!
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/cleverhospitalitymanagement/" target="_blank" rel="noopener noreferrer">
                <img src={Facebook} className="fab fa-facebook-f text-white/80 hover:text-white hover:scale-125 transition-transform duration-300" />
              </a>
              <img src={Twitter} className="fab fa-twitter text-white/80 hover:text-white pl-[5px] hover:scale-125 transition-transform duration-300" />
              <img src={Instagram} className="fab fa-instagram text-white/80 hover:text-white pl-[5px] hover:scale-125 transition-transform duration-300" />
              <img src={LinkedIn} className="fab fa-linkedin-in text-white/80 hover:text-white pl-[5px] hover:scale-125 transition-transform duration-300" />
              <img src={YouTube} className="fab fa-youtube text-white/80 hover:text-white pl-[5px] hover:scale-125 transition-transform duration-300" />
            </div>
          </div>

          {/* Product */}
          <div className="text-left min-w-[160px] ml-[350px] ">
            <h3 className="text-[#FCAF26] font-semibold mb-4 text-[22px]">Product</h3>
            <ul className="text-[20px] text-[#7F7CA2]/70 space-y-2 pl-0">
              <li><a >Features</a></li>
              <li><a >Pricing</a></li>
              <li><a >Case studies</a></li>
              <li><a >Reviews</a></li>
              <li><a >Updates</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="text-left min-w-[160px] ml-[255px]">
            <h3 className="text-[#FCAF26] font-semibold mb-4 text-[22px]">Company</h3>
            <ul className="text-[20px] text-[#7F7CA2]/70 space-y-2 pl-0">
              <li><a >About</a></li>
              <li><a >Contact us</a></li>
              <li><a >Careers</a></li>
              <li><a >Culture</a></li>
              <li><a >Blog</a></li>
            </ul>
          </div>

          {/* Support */}
          <div className="text-left min-w-[160px] ml-[150px]">
            <h3 className="text-[#FCAF26] font-semibold mb-4 text-[22px]">Support</h3>
            <ul className="text-[20px] text-[#7F7CA2]/70 space-y-2 pl-0">
              <li><a >Getting started</a></li>
              <li><a >Help center</a></li>
              <li><a >Server status</a></li>
              <li><a >Report a bug</a></li>
              <li><a >Chat support</a></li>
            </ul>
          </div>
        </div>

        {/* Divider & Copyright */}
        <div className="border-t border-white/10 mt-12 pt-6 text-center text-sm text-white/60">
          <span>Copyright © 2024 Clever Hospitality Management | All Rights Reserved | </span>
          <a className="text-yellow-400 hover:underline">Terms and Conditions</a>
          <span> | </span>
          <a className="text-yellow-400 hover:underline">Privacy Policy</a>
        </div>
      </footer>


      {/* ✅ Mobile Version */}
      <footer className="bg-[#0B1D26] text-white h-[664px] py-8 px-6 block md:hidden p-2">
        {/* Logo & Desc */}
        <div className="flex flex-col items-start text-left mb-6 pl-2">
          <img src={logo_hor} alt="Clever" className="h-[64px] w-[206px] mb-4" />
          <p className="text-[#7F7CA2]/70 text-[14px] leading-relaxed max-w-[300px]">
            Get out of there and discover your<br />
            next slope, mountain and destination!
          </p>
        </div>


        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          <a href="https://www.facebook.com/cleverhospitalitymanagement/" target="_blank" rel="noopener noreferrer">
            <img src={Facebook} className="w-[36px] h-[36px]" />
          </a>
          <img src={Twitter} className="w-[36px] h-[36px]" />
          <img src={Instagram} className="w-[36px] h-[36px]" />
          <img src={LinkedIn} className="w-[36px] h-[36px]" />
          <img src={YouTube} className="w-[36px] h-[36px]" />
        </div>

        {/* 3 Columns (Stacked) */}
        <div className="grid grid-cols-3 mr-[20px] gap-4 text-center ">
          <div className='h-[256px] w-[108px] text-left'>
            <h4 className="text-[#FCAF26] font-semibold mb-2 text-[18px] mb-[40px]">Product</h4>
            <ul className="text-[14px] text-[#7F7CA2]/70 ">
              <li className='mb-[20px]'>Features</li>
              <li className='mb-[20px]'>Pricing</li>
              <li className='mb-[20px]'>Case studies</li>
              <li className='mb-[20px]'>Reviews</li>
              <li className='mb-[20px]'>Updates</li>
            </ul>
          </div>
          <div className='h-[256px] w-[108px text-left'>
            <h4 className="text-[#FCAF26] font-semibold mb-2 text-[18px] mb-[40px]">Company</h4>
            <ul className="text-[14px] text-[#7F7CA2]/70 ">
              <li className='mb-[20px]'>About</li>
              <li className='mb-[20px]'>Contact</li>
              <li className='mb-[20px]'>Careers</li>
              <li className='mb-[20px]'>Culture</li>
              <li className='mb-[20px]'>Blog</li>
            </ul>
          </div>
          <div className='h-[256px] w-[108px] text-left'>
            <h4 className="text-[#FCAF26] font-semibold mb-2 text-[18px] mb-[40px]">Support</h4>
            <ul className="text-[14px] text-[#7F7CA2]/70 ">
              <li className='mb-[20px]'>Getting started</li>
              <li className='mb-[20px]'>Help center</li>
              <li className='mb-[20px]'>Server status</li>
              <li className='mb-[20px]'>Report a bug</li>
              <li className='mb-[20px]'>Chat support</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-6 pt-4 text-center text-[10px] text-white/60 leading-relaxed px-4">
          <span>Copyright © 2024 Clever Hospitality Management | All Rights Reserved | </span>
          <a className="text-yellow-400 hover:underline">Terms and Conditions</a>
          <span> | </span>
          <a className="text-yellow-400 hover:underline">Privacy Policy</a>
        </div>

      </footer>
    </>
  );
}
